// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2dJWh","col":"styles_col__11AnD","actions":"styles_actions__3cKOE","conflict":"styles_conflict__3N8_J"};